import { ReactFlowProvider } from "@xyflow/react";
import PageTop from "@/Pages/Project/PageTop";
import PageSeletor from "@/Pages/Project/Flow/Right/PageSeleltor";
import { useParams } from "react-router-dom";
// import materialsDB from "@/constants/materialsDB";
// import { rebuildFormula } from "@/config/func";
// import CalculateTask3DYCZPage from "./calculateTask3DYCZPage";
// import CalculateTask3LGPage from "./calculateTask3LG";
import "./../index.less";
// import { getJob } from "@/services/common";
// import userInfo from "@/Components/user";
// import ResultJSON from "./resultJSON";
import ResultPageFrame from "./ResultPageFrame";

const Component = () => {
  // const { state, actions } = useAppContext();
  //   const location = useLocation();
  // 使用 useParams 获取URL中的参数
  const params = useParams<{ k: string; f: string; j: string }>();
  // const [activeTab, setActiveTab] = useState("element");
  // const [transInput, setTransInput] = useState({});
  // const [input, setInput] = useState<any>({});
  // const [response, setResponse] = useState<any>({});

  // useEffect(() => {
  //   getJob(params.j, userInfo.access_token).then((r) => {
  //     if (r.status === 200) {
  //       setInput({
  //         name: r.data.name,
  //         flow_id: r.data.flow_id,
  //         description: r.data.description,
  //         inputs: JSON.parse(r.data.input)
  //       });
  //       setResponse(JSON.parse(r.data.output.replace(/NaN/g, '0')));
  //       // console.log('r.data.output', JSON.parse(r.data.output.replace(/NaN/g, '0')));
  //     }
  //   });
  // }, []);

  // const transformMaterials = (rawMaterials: any[]) => {
  //   return rawMaterials.map((material, index) => {
  //     const m: any = materialsDB.find((item: any) => item.cas === material.cas);
  //     return {
  //       cas: material.cas,
  //       Molecular_formula: rebuildFormula(m.Molecular_formula),
  //       Name_ZH: m.Name_ZH,
  //       MW: m.MW,
  //       index: index,
  //       molar_frac: material.molar_frac,
  //     };
  //   });
  // };

  // Tab 配置
  // const tabs = [
  //   { key: "element", label: "单元操作" },
  //   { key: "stream", label: "流股" },
  //   { key: "heat", label: "热交换" },
  //   { key: "economy", label: "经济效益" },
  //   { key: "json", label: "完整输入输出" },
  // ];

  return (
    <ReactFlowProvider>
      <PageTop
        mainContent={
          <div className="settingSelectorArea">
            <PageSeletor />
          </div>
        }
      />
      <ResultPageFrame job_id={params.j} type="job" />
    </ReactFlowProvider>
  );
};

export default Component;
